import { FunctionComponent } from 'react'

import styled from 'styled-components'

import { baseColors } from '@fairhq/common'

const LayoutContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${baseColors.contentContent};
  color: ${baseColors.contentInverseContent};

  h1,
  h2 {
    font-size: 42px;
    font-family: Gilbert, sans-serif;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

interface SignUpLayoutProps {
  children?: React.ReactNode
}

export const ErrorLayout: FunctionComponent<SignUpLayoutProps> = ({
  children,
}) => (
  <LayoutContainer>
    <Content>{children}</Content>
  </LayoutContainer>
)
